import React, { useState, useEffect } from "react";
import {
  Page,
  Document,
  Image,
  StyleSheet,
  Font,
  View,
  Text
} from "@react-pdf/renderer";
import bahijR from "../../assets/fonts/Bahij-Nazanin-Regular.ttf";
import bahijB from "../../assets/fonts/Bahij-Nazanin-Bold.ttf";

import pageCover from "../../assets/images/export_duty_letter_cover.jpg";
//import pageCover from "../../assets/images/export_duty_letter_cover_tt.jpg";

export default function PDFLetter({ v }) {
  const [splitedMainText, setSplitedMainText] = useState([]);
  const [splitedNoteText, setSplitedNoteText] = useState([]);
  const [union, setUnion] = useState(null);

  useEffect(() => {
    Font.register({ family: "bahijR", src: bahijR });
    Font.register({ family: "bahijB", src: bahijB });
    Font.register({ family: "amiriR", src: bahijB });
  }, []);

  const getVar = (d, f = true) => (f ? ` ) ${d} ( ` : `${d}`);

  const commaOrAnd = i => {
    const l = v?.model?.tariff?.items?.length;
    if (l > 1) {
      return i < l - 2 ? "،" : i < l - 1 ? " و " : "";
    }
    return "";
  };

  const cn = n => v?.com?.numConvertAndRevrse(n);

  useEffect(() => {
    let mainText =
      `شرکت محترم تجارتی ${getVar(
        v?.model?.company?.name_af
      )} دارنده  جواز نامه تجارتی شماره ${getVar(
        v?.model?.company?.license_number
      )} خواهان  صدور` +
      `${v?.model?.tariff?.items
        ?.map(
          (item, i) =>
            ` ${getVar(cn(item?.quantity))} متر مربع ${getVar(
              item?.category?.label,
              false
            )} ${commaOrAnd(i)}`
        )
        .join("")} ` +
      ` را به کشور  ${getVar(
        v?.model?.invoice?.shipping_state?.name_af
      )} بوده که بعد از تعین نمودن نوعیت، جنسیت و کیفیت غرض اخذ فورم ${getVar(
        v?.model?.form
      )}` +
      `به ریاست محترم گمرک ${v?.model?.invoice?.export_type?.label} اطمینان داده میشود که ` +
      `${v?.model?.tariff?.items
        ?.map(
          (item, i) =>
            ` ${getVar(item?.category?.label, false)} باب مذکور نوع ${getVar(
              item?.item_type
            )} ${
              item?.sort ? " سورت " + getVar(cn(item?.sort)) : ""
            } ${commaOrAnd(i)}`
        )
        .join("")}` +
      ` دست بافت وطنی میباشد. ` +
      ` طبق انوایس شماره  ${getVar(
        v?.model?.invoice?.label
      )} شرکت مربوطه بعد از تائیدی ضم مکتوب هذا غرض اجراآت بعدی شما ارسال است. `;

    mainText = v?.com.removeDoubleSpaces(mainText); //remove duoble spaces from the text
    const _splitedMainText = mainText.split(" ");
    setSplitedMainText(_splitedMainText);
  }, []);

  useEffect(() => {
    const noteText = ` نوت: قرار تعرفه نمبر  ${getVar(
      cn(v?.model?.tariff?.id)
    )}  ${v?.model?.tariff?.aviza_date ? "مورخ" : ""} ${v?.com?.getShamshiDate(
      v?.model?.tariff?.aviza_date
    )} پول حق الخدمت به بانک تحویل گردید. `;
    const _splitText = noteText.split(" ");
    setSplitedNoteText(_splitText);
  }, []);

  const getUnion = async () => {
    try {
      const res = await v.http.get("api/settings");
      console.log("Get union ", res);
      if (res.data.success) {
        const data = res?.data?.data;
        setUnion(data);
      }
    } catch (error) {
      console.log("Union fetch error ", error);
    }
  };

  useEffect(() => {
    if (union === null) getUnion();
  }, []);

  return (
    <>
      {" "}
      {union && (
        <Document>
          <Page size="A4" style={styles.page}>
            <View style={styles.pageBackground}>
            <Image src={pageCover} style={{ width: "100%", height: "100%" }} />
            </View>

            <View style={styles.mainView}>
              <View
                style={{
                 
                  marginRight: 35,
                  direction: "rtl",
                  marginTop: 38
                }}
              >
                <Text>{`${v?.com?.getShamshiDate(v.model?.updated_at)}`}</Text>
              </View>

              <View style={styles.subject}>
               {/* <Text>{`بریاست محترم عمومی اتاق تجارت و سرمایه گذاری!`} </Text> */}
                <Text>{`به مقام محترم مرکز جمع‌آوری عوايد!`} </Text>
              </View>

              <View style={[styles1.flexRowReverse, styles1.flexWrap]}>
                {splitedMainText.map((word, idx) => {
                  return (
                    <Text style={styles1.ml1} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>

              <View style={[styles1.flexRowReverse, styles1.flexWrap]}>
                {splitedNoteText.map((word, idx) => {
                  return (
                    <Text style={styles1.ml1} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>

              <View>
                <Text style={{ ...styles.fontB }}>با احترام</Text>
              </View>

              <View style={{ marginTop: 70 }}>
                {/* <Text>{union?.ceo}</Text> */}
                <Text>{v?.model?.zone_manager?.full_name}</Text>
                <Text>
                  {Number(v?.model?.company?.zoneID) === 1
                    ? ` سرپرست هیئت عامل اتحادیه مولدین و صادرکنندگان قالین افغانستان  `
                    : `   آمریت اتحاديه مؤلدین وصادرکنندگان قالين ${v?.model?.company?.zone?.label} `}
                </Text>
              </View>
            </View>
            <View style={{ marginTop: 0, paddingRight: 55 }}>
              <Text style={styles.fontB}>کاپی‌ها:</Text>
              <Text>
                {" "}
                {`بریاست محترم گمرک ${v?.model?.invoice?.export_type?.label}`}{" "}
              </Text>
              <Text>بریاست محترم انکشاف صادرات</Text>
              <Text>به مدیریت محترم عمومی مالی و اداری</Text>
            </View>
            {v?.model?.qrText && (
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  fontSize: 8,
                  height: "60px",
                  width: "95%",
                  position: "absolute",
                  bottom: 0,
                  border: "0.3px solid black",
                  margin: 10
                }}
              >
                <Image
                  allowDangerousPaths
                  src={document.getElementById(v?.model?.id).toDataURL()}
                  style={{ height: "60px", width: "60px" }}
                />
                <View style={{ display: "inline-flex" }}>
                  <Text>Check the authenticity of this document:</Text>
                  <Text>
                    https://acmeg.org.af/db/invoice-checking/{v?.model?.id}
                  </Text>
                  <Text style={{ color: "gray" }}>
                    Scan the QR code or open the link manuallyin order to check
                    for authenticity of this document.
                  </Text>
                </View>
              </View>
            )}
          </Page>
        </Document>
      )}
    </>
  );
}
const styles1 = StyleSheet.create({
  flexRowReverse: {
    flexDirection: "row-reverse",
    marginBottom: 18,
    lineHeight: 2,
    justifyContent: "justify"
  },
  flexWrap: {
    flexWrap: "wrap"
  },
  ml1: {
    marginLeft: "2pt"
  }
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "bahijR",
    fontSize: 14,
    textAlign: "right",
     position: "relative" // Add this
  },
    pageBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    zIndex: -1 // Ensure it stays behind content
  },
  mainView: {
    paddingTop: 80,
    marginLeft: 55,
    paddingRight: 55,
    lineHeight: 1.5,
    height: "77%"
  },

  subject: {
    marginTop: 55,
    direction: "rtl",
    fontFamily: "bahijB",
    marginBottom: 15
  },
  fontB: {
    fontFamily: "bahijB"
  }
});
